import React, { useEffect } from "react";
import { SEO } from "../components/SEO";
import { Mail, Phone, MapPin, MessageSquare, ChevronRight } from "lucide-react";
import { Button } from "../components/ui/Button";

export const Contato = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white min-h-screen pb-20">
      <SEO 
        title="Fale Conosco | RosTech" 
        description="Entre em contato com a RosTech. Suporte, comercial e parcerias."
        canonicalUrl="/contato"
      />

      <section className="pt-32 pb-20 bg-slate-900 border-b border-slate-800 text-white overflow-hidden relative">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-20 pointer-events-none">
          <div className="absolute -top-[20%] right-[10%] w-[50%] h-[70%] rounded-full bg-blue-600 blur-[120px]"></div>
          <div className="absolute top-[20%] left-[10%] w-[50%] h-[70%] rounded-full bg-blue-400 blur-[120px]"></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10 text-center">
          <h1 className="text-5xl md:text-7xl font-black text-white mb-8 tracking-tight">
            Estamos aqui para <span className="text-blue-400">ajudar</span>.
          </h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto mb-12 leading-relaxed">
            Dúvidas sobre os planos? Precisa de suporte com o sistema? Quer ser nosso parceiro? Entre em contato agora mesmo pelos nossos canais oficiais.
          </p>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            
            {/* Contact Info */}
            <div className="space-y-12">
               <div>
                 <h2 className="text-3xl font-black text-slate-900 mb-6 leading-tight">Fale com a nossa equipe</h2>
                 <p className="text-slate-600 text-lg mb-8">Nossa central de atendimento está pronta para tirar todas as suas dúvidas. Respondemos rapidamente dentro do horário comercial.</p>
               </div>

               <div className="grid gap-6">
                 <div className="flex p-6 border border-slate-100 rounded-2xl bg-white shadow-sm hover:shadow-md transition-shadow group">
                    <div className="w-14 h-14 bg-emerald-50 rounded-xl flex items-center justify-center mr-6 shrink-0 group-hover:bg-emerald-100 transition-colors">
                      <MessageSquare className="w-6 h-6 text-emerald-600" />
                    </div>
                    <div>
                       <h3 className="font-bold text-slate-900 mb-1">WhatsApp de Vendas</h3>
                       <p className="text-slate-600 font-medium mb-2">(24) 9.9281-8632</p>
                       <p className="text-slate-400 text-sm">Seg a Sex das 08h às 18h</p>
                    </div>
                 </div>

                 <div className="flex p-6 border border-slate-100 rounded-2xl bg-white shadow-sm hover:shadow-md transition-shadow group">
                    <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center mr-6 shrink-0 group-hover:bg-blue-100 transition-colors">
                      <Mail className="w-6 h-6 text-blue-600" />
                    </div>
                    <div>
                       <h3 className="font-bold text-slate-900 mb-1">E-mail Comercial</h3>
                       <p className="text-slate-600 font-medium mb-2">contato@rostech.com.br</p>
                       <p className="text-slate-400 text-sm">Resposta em até 24h úteis</p>
                    </div>
                 </div>

                 <div className="flex p-6 border border-slate-100 rounded-2xl bg-white shadow-sm hover:shadow-md transition-shadow group">
                    <div className="w-14 h-14 bg-slate-50 rounded-xl flex items-center justify-center mr-6 shrink-0 group-hover:bg-slate-100 transition-colors">
                      <Phone className="w-6 h-6 text-slate-600" />
                    </div>
                    <div>
                       <h3 className="font-bold text-slate-900 mb-1">Suporte Técnico</h3>
                       <p className="text-slate-600 font-medium mb-2">suporte@rostech.com.br</p>
                       <p className="text-slate-400 text-sm">Disponível para plano V3+</p>
                    </div>
                 </div>
               </div>
            </div>

            {/* Visual/Form Area */}
            <div className="bg-slate-50 border border-slate-200 rounded-3xl p-8 lg:p-10 relative overflow-hidden flex flex-col justify-between">
               <img src="https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&q=80&w=800" alt="Equipe de Suporte" className="absolute top-0 right-0 w-full h-64 object-cover z-0 hidden sm:block opacity-60 mix-blend-multiply" />
               <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-b from-transparent to-slate-50 z-0"></div>
               
               <div className="relative z-10 space-y-6 mt-32 sm:mt-48">
                 <div className="bg-white p-8 rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100">
                    <h3 className="font-bold text-xl text-slate-900 mb-6">Mande uma mensagem direta</h3>
                    <form className="space-y-4">
                       <div>
                         <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Nome Completo</label>
                         <input type="text" className="w-full h-12 px-4 rounded-xl border border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all placeholder:text-slate-400" placeholder="Seu nome da Silva" />
                       </div>
                       <div>
                         <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">E-mail Comercial</label>
                         <input type="email" className="w-full h-12 px-4 rounded-xl border border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all placeholder:text-slate-400" placeholder="seuemail@oficina.com" />
                       </div>
                       <div>
                         <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Mensagem</label>
                         <textarea className="w-full h-32 p-4 rounded-xl border border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all resize-none placeholder:text-slate-400" placeholder="Como podemos te ajudar?"></textarea>
                       </div>
                       <Button size="lg" className="w-full shadow-lg shadow-blue-600/20 group">
                          Enviar Mensagem <ChevronRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                       </Button>
                    </form>
                 </div>
               </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};
